import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const componentDetailConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default componentDetailConfig;
